import type { Resource } from "../lib/useResource";
import { StateMessage } from "./StateMessage";

interface ResourceStatusProps {
  resource: Resource<unknown>;
  /** Title while it loads, e.g. "Loading dues…". */
  loading: string;
  /** Title if it fails; the error's own message is the detail. */
  error: string;
}

/**
 * The loading and error messages every `useResource` reader shows, and
 * nothing once it's ready, so the caller renders only its ready (and empty)
 * states. Those differ per page; these two never do.
 */
export function ResourceStatus({ resource, loading, error }: ResourceStatusProps) {
  if (resource.status === "loading") return <StateMessage variant="loading" title={loading} />;
  if (resource.status === "error") return <StateMessage variant="error" title={error} detail={resource.error.message} />;
  return null;
}
